import React from 'react';
import LocationSearchAutocomplete from './LocationSearchAutocomplete.jsx';
import {
  geocode as bingGeocode,
  getSuggestions as getBingSuggestions,
} from './bing-geocoder.js';
import {SOURCE_TYPES} from './util.js';

/**
 * @param {array} [center] - optional center coordinates to bias results
 * @param {string} apiKey - Bing API key
 * @param {string} inputValue - The input value
 * @param {function} onClear - callback fired when the input is cleared
 * @param {function} onError - callback fired when there is an error fetching from provided Promises
 * @param {function} onSelectOption - callback fired when an option is selected from the results list
 * @param {array[Promises]} [suggestionsPromises] - optional array of promises
 */
const BingLocationSearch = ({
  center,
  apiKey,
  inputValue = '',
  onClear,
  onError,
  onSelectOption,
  suggestionsPromises = [],
}) => {
  const onSuggestBingResults = query =>
    getBingSuggestions(query, center, apiKey);

  const handleBingResultSelection = result => {
    bingGeocode(result.query, center, apiKey).then(feature => {
      if (!feature.bbox) {
        // eslint-disable-next-line no-console
        console.error('Bing Geocoder: result did not include bbox');
        return;
      }
      if (onSelectOption) {
        onSelectOption({
          ...result,
          ...feature,
        });
      }
    });
  };

  const onSelectResult = result => {
    if (result) {
      if (result.source === SOURCE_TYPES.BING) {
        handleBingResultSelection(result);
      } else {
        if (onSelectOption) {
          onSelectOption(result);
        }
      }
    }
  };

  return (
    <LocationSearchAutocomplete
      onSelectOption={onSelectResult}
      suggestionsPromises={[...suggestionsPromises, onSuggestBingResults]}
      inputValue={inputValue}
      onClear={onClear}
      onError={onError}
    />
  );
};

export default BingLocationSearch;
